import React from 'react';
import { connect } from 'react-redux';


import { getList, getTotal } from '../../redux/actions/actions'
import Kus from './Kus';
import Mis from './Mis';
import Millal from './Millal';


export const Filters = () => {
    return (
        <div className="filters">
            <Kus />
            <Mis />
            <Millal />
        </div>
    );
}

//const mapStateToProps = (state: any) => state;

  // export default VisibilityFilters;
  export default connect(
    null,
    {getList,getTotal}
  )(Filters);

